import { hasAccess, type User } from '@/features/auth';
import type { NavItem } from './navItems';

export type NavAccessContext = { user: User | null; isInternal: boolean };

type Gated = Pick<NavItem, 'requiredRoles' | 'requiredPermissions'>;

const canSee = (entry: Gated, user: User | null): boolean =>
    hasAccess(user, { roles: entry.requiredRoles, permissions: entry.requiredPermissions });

export function visibleNavItems(items: NavItem[], { user, isInternal }: NavAccessContext): NavItem[] {
    return items.flatMap((item) => {
        if (item.requiresInternal && !isInternal) return [];
        if (!canSee(item, user)) return [];
        if (!item.subItems) return [item];

        const subItems = item.subItems.filter((sub) => canSee(sub, user));
        return subItems.length > 0 ? [{ ...item, subItems }] : [];
    });
}
